import { useQuery } from '@urql/next'
import { useSession } from 'next-auth/react'
import { GetUserProfileByIdDocument } from '@/gql/generated/graphql'
import { createUrqlNextCacheContext, createTagWithVal } from '@utils/common'
import { USER_REVALIDATE_TAG } from '@/app/constants/common'
import { useMemo } from 'react'

export function useProfilePicture() {
  const { data: session } = useSession()
  const profileId = session?.user?.profileId

  const urqlOperationContext = useMemo(() => {
    if (!profileId) return {}

    return {
      ...createUrqlNextCacheContext({
        tags: [USER_REVALIDATE_TAG, createTagWithVal(USER_REVALIDATE_TAG, profileId.toString())],
        requestPolicy: 'cache-first'
      })
    }
  }, [profileId])

  const [result] = useQuery({
    query: GetUserProfileByIdDocument,
    variables: { id: profileId as number },
    pause: !profileId,
    context: urqlOperationContext
  })

  const profilePictureUrl = result.data?.user_profiles_by_pk?.profile_picture?.url

  return {
    profilePictureUrl,
    isLoading: result.fetching,
    error: result.error
  }
}
